import api from './api';
import fileDownload from 'js-file-download'

const getAllDealers = (page, name = null, territory = null, dealerGroup = null) => {
    return api
        .get('/dealers', { 
            params: { 
                includeUsers: true, 
                includeProducts: true, 
                includePricingPositions: true,
                page,
                name,
                territory,
                dealerGroup
            }
        })
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const getDealer = (id) => {
    return api
        .get('/dealers/' + id, { params: { includeUsers: true, includeProducts: true, includePricingPositions: true }})
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const getDealerInvoice = (dealerId, month, year) => {
    return api
        .get('/dealers/invoice', { 
            params: {  
                dealerId: dealerId,
                month: month,
                year: year
            },
            responseType: 'blob'
        })
        .then(response => {
            return fileDownload(response.data, 'invoice.pdf')
        })
        .catch(err => {
            throw err.response.data
        });
};

const getDealerCreditMemo = (dealerId, month, year) => {
    return api
        .get('/dealers/creditMemo', { 
            params: { 
                dealerId,
                month,
                year
            },
            responseType: 'blob'
        })
        .then(response => {
            return fileDownload(response.data, 'creditMemo.pdf')
        })
        .catch(err => {
            throw err.response.data
        });
};

const createDealer = (dealerPayload) => {
    return api
        .post('/dealers/create', dealerPayload)
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const updateDealer = (dealerPayload) => {
    return api
        .post('/dealers/update', dealerPayload)
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const linkProductToDealer = (dealerPayload) => {
    return api
        .post('/dealers/linkProducts', dealerPayload)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err.response.data
        });
};

const unlinkProductFromDealer = (dealerPayload) => {
    return api
        .post('/dealers/unlinkProducts', dealerPayload)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err.response.data
        });
};


const linkUserToDealer = (dealerPayload) => {
    return api
        .post('/dealers/linkUsers', dealerPayload)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err.response.data
        });
};

const unlinkUserFromDealer = (dealerPayload) => {
    return api
        .post('/dealers/unlinkUsers', dealerPayload)
        .then(response => {
            return response
        })
        .catch(err => {
            throw err.response.data
        });
};

const getAllDealerGroups = () => {
    return api
        .get('/groups')
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const createDealerGroup = (name) => {
    return api
        .post('/groups/create', name)
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const updateDealerGroup = (dealerGroupPayload) => {
    return api
        .post('/groups/update', dealerGroupPayload)
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};

const deleteDealerGroup = (dealerGroupPayload) => {
    return api
        .post('/groups/delete', dealerGroupPayload)
        .then(response => {
            return response.data
        })
        .catch(err => {
            throw err.response.data
        });
};


const DealerService = {
    getAllDealers,
    getDealer,
    getDealerInvoice,
    getDealerCreditMemo,
    createDealer,
    updateDealer,
    linkProductToDealer,
    unlinkProductFromDealer,
    linkUserToDealer,
    unlinkUserFromDealer,
    getAllDealerGroups,
    createDealerGroup,
    updateDealerGroup,
    deleteDealerGroup
};

export default DealerService;